module.exports = __webpack_public_path__ + "static/media/user-add.384b718a.svg";